import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const RecommendationsPanel = ({ recommendations, refreshKey }) => {
  const navigate = useNavigate();

  // Mock recommendations removed - ready for live data integration
  const defaultRecommendations = [];

  const displayRecommendations = recommendations || defaultRecommendations;

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'accent';
      case 'medium': return 'warning';
      case 'low': return 'primary';
      default: return 'primary';
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case 'high': return 'High Priority';
      case 'medium': return 'Medium Priority';
      case 'low': return 'Suggested';
      default: return 'Suggested';
    }
  };

  const handleActionClick = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/10 rounded-lg p-4 md:p-6 shadow-therapeutic">
      <div className="flex items-start gap-3 mb-6">
        <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Sparkles" size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            Claude-Powered Recommendations
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            Personalized insights for deepening your connection
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {displayRecommendations?.map((rec) => (
          <div
            key={rec?.id}
            className="bg-card border border-border rounded-lg p-4 md:p-5 hover:shadow-therapeutic transition-therapeutic"
          >
            <div className="flex items-start gap-3">
              <div className={`flex items-center justify-center w-10 h-10 bg-${getPriorityColor(rec?.priority)}/10 rounded-md flex-shrink-0`}>
                <Icon name={rec?.icon} size={20} color={`var(--color-${getPriorityColor(rec?.priority)})`} />
              </div>
              
              <div className="flex-1 space-y-3">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
                      {rec?.title}
                    </h4>
                    <span className={`text-xs font-medium px-2 py-1 rounded-full bg-${getPriorityColor(rec?.priority)}/10 text-${getPriorityColor(rec?.priority)}`}>
                      {getPriorityLabel(rec?.priority)}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {rec?.description}
                  </p>
                </div>

                {rec?.action && rec?.actionPath && (
                  <button
                    onClick={() => handleActionClick(rec?.actionPath)}
                    className="flex items-center gap-2 px-4 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md transition-therapeutic text-sm font-medium"
                  >
                    <span>{rec?.action}</span>
                    <Icon name="ArrowRight" size={16} color="currentColor" />
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-card/50 border border-border/50 rounded-md">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground leading-relaxed">
            These recommendations are generated by Claude AI based on your relationship patterns, mood data, and communication history. 
            All analysis is performed with privacy-first principles, and data never leaves your secure environment.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RecommendationsPanel;